<template>
  <Modal
    id="CarImagesEdit"
    width="60%"
    :open="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
  >
    <Row align="middle" justify="center">
      <Col span="18" >
        <Row>
          <Col span="24">
            <Form
              ref="carImagesForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                  <Col span="10">
                    <FormItem :label="$t('carImages.field.id_car')" name="idCar">
                        <!--关联表的下拉选择-->
                        <Select
                                v-model:value="form.idCar"
                                :placeholder="$t('carImages.validate.required.id_car')"
                                :dropdownStyle="{ zIndex: 9999999950 }"
                        >
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['carList']" :value="item['idCar']">{{ item['model'] }}</SelectOption>
                        </Select>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('carImages.field.url')" ref="url" name="url">
                      <UploadImage :url="form.url"
                                   @new_image_url="(value) => {
                                      this.$refs.url.clearValidate()
                                      this.form.url = value
                                   }"
                                   ref="upload_url"
                      />
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('carImages.field.upload_time')" name="uploadTime">
                      <DatePicker show-time valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.uploadTime" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                  </Col>
                  <!-- <Col span="10">
                    <FormItem :label="$t('carImages.field.tenant_key')" name="tenantKey">
                                            <Input :placeholder="$t('carImages.validate.required.tenant_key')"
                                                   v-model:value="form.tenantKey">
                                            </Input>
                  </FormItem>
                  </Col> -->
                <!--判断是否有子表，如果有则直接加入子表管理逻辑-->
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
  Space,
  Card,
  Table,
  Popconfirm,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { CarImagesAdd, CarImagesEdit } from "@/api/carImages";
import { CarListAll } from "@/api/car"
import UploadImage from "@/components/Common/UploadImage"

export default {
  name: "CarImagesEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    MinusCircleOutlined,
    ExclamationCircleOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    UploadImage,
    Descriptions,
    DescriptionsItem,
    Space,
    Card,
    Table,
    Popconfirm,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idCarIma : "",
        idCar : "",
        url : "",
        uploadTime : "",
        tenantKey : "",
      },
      fileList: {
      },
      selectList: {
        carList: [],
      },
      validateRules: {
        idCarIma: [
          {
            required: true,
            message: this.$t("carImages.validate.required.id_car_ima"),
            trigger: "change",
            type: "number",
          },
        ],
        idCar: [
          {
            required: true,
            message: this.$t("carImages.validate.required.id_car"),
            trigger: "change",
            type: "number",
          },
        ],
        url: [
          {
            required: true,
            message: this.$t("carImages.validate.required.url"),
            trigger: "change",
          },
        ],
        uploadTime: [
          {
            required: true,
            message: this.$t("carImages.validate.required.upload_time"),
            trigger: "change",
          },
        ],
        tenantKey: [
          {
            required: true,
            message: this.$t("carImages.validate.required.tenant_key"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  watch: {
      "visible": {
          deep: true,
          handler: function (newValue, oldValue) {
              if (!newValue) {
                  this.$emit("updateList");
              }
          }
      }
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.getCarList();
      if (this.$refs.upload_url) {
          this.$refs.upload_url.change_url("")
      }
      this.visible = true;
    },
    async editShow(obj) {
      this._resetData();
      if (this.$refs.upload_url) {
          this.$refs.upload_url.change_url("")
      }
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.getCarList();
        if (this.$refs.upload_url) {
            this.$refs.upload_url.change_url(this.form.url)
        }
      this.visible = true;
    },
    submit() {
      this.$refs["carImagesForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new CarImagesAdd();
              break;
            case "edit":
              console.log("edit");
              api = new CarImagesEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 == parseInt(response.data.code)) {
              message.success(this.$t("succeedMsg.0"));
              this.$emit("updateList",response.data.data);
              this.visible = false;
            } else {
              if(response.data.code !== undefined){message.error(this.$t("errorMsg." + response.data.code));}
            }
          });
        })
        .catch(() => {
        });
    },
    getCarList() {
      const api = new CarListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
            this.selectList.carList = response.data.data;
        } else {
            if(response.data.code !== undefined){message.error(this.$t("errorMsg." + response.data.code));}
        }
      });
    },
    // reset data
    _resetData() {
      this.form = {
        idCarIma : "",
        idCar : "",
        url : "",
        uploadTime : "",
        tenantKey : "",
      };
    },
  },
};
</script>

<style lang="less">
</style>
